const escapeRegex = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const collectMatchingKeys = (node, searchLower, pathParts, results) => {
  if (node == null || typeof node !== 'object') return;
  for (const key of Object.keys(node)) {
    if (pathParts.length === 0 && key === '_meta') continue;
    const value = node[key];
    const nextPath = [...pathParts, key];
    if (typeof value === 'string') {
      if (value.toLowerCase().includes(searchLower)) {
        results.push(nextPath.join('.'));
      }
    } else if (value && typeof value === 'object') {
      collectMatchingKeys(value, searchLower, nextPath, results);
    }
  }
};

export const resolveActionKeysToRegex = (i18nInstance, searchTerm) => {
  if (!searchTerm || typeof searchTerm !== 'string') return null;
  const trimmed = searchTerm.trim();
  if (!trimmed) return null;

  const lang = i18nInstance?.resolvedLanguage ?? i18nInstance?.language;
  if (!lang || typeof i18nInstance?.getResourceBundle !== 'function') return null;

  const bundle = i18nInstance.getResourceBundle(lang, 'audit');
  if (!bundle || typeof bundle !== 'object') return null;

  const matches = [];
  collectMatchingKeys(bundle, trimmed.toLowerCase(), [], matches);
  if (matches.length === 0) return null;

  return matches.map(k => `audit:${escapeRegex(k)}`).join('|');
};
